import { render, staticRenderFns } from "./TrTextArea.vue?vue&type=template&id=5dbdb1e0&lang=true&"
import script from "./TrTextArea.vue?vue&type=script&lang=js&"
export * from "./TrTextArea.vue?vue&type=script&lang=js&"
import style0 from "./TrTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports